import React from "react";
import { useData, tail } from "../lib/store.jsx";
import { Kpi, Panel, HeadcountChart, HBars } from "../components/ui.jsx";
import { pct2 } from "../lib/data.js";

const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export default function Staffing() {
  const { d, m, period } = useData();

  const tov = [...d.turnover]
    .filter((r) => r.headcount_end != null)
    .sort((a, b) => a.period.localeCompare(b.period));
  const shown = tail(tov, period || 12);
  const hcData = shown.map((r) => ({
    x: MON[+r.period.slice(5, 7) - 1],
    Headcount: +r.headcount_end,
    Joined: +r.joined || 0,
    Separations: +r.separations || 0,
  }));
  const leftYear = shown.length ? shown[0].period.slice(0, 4) : "";
  const rightYear = shown.length
    ? shown[shown.length - 1].period.slice(0, 4) : "";

  const turnover = m.turnoverByFy.slice(-3);

  return (
    <>
        <Kpi label="Headcount" className="s4" color="#c8e64a" value={m.headcount || 0}
          fmt={(x) => Math.round(x)} meta="on the books" />
        <Kpi label="Employee Turnover" className="s4" color="#c8e64a"
          value={m.turnoverTtm == null ? 0 : m.turnoverTtm}
          fmt={pct2} meta="12 months to date"
          badge={{ kind: "up", text: "▼ vs 30% sector" }} />
        <Kpi label="Agency Use" className="s4" color="#d9b892" text="Zero" meta="since April 2023" />
        <Panel className="s5" title="Turnover — last 3 years"
          sub="average monthly turnover by financial year"
          right={<span className="tiny muted">Industry avg 30%</span>}>
          <HBars data={turnover} unit="%" max={3} />
          <div className="legend">
            <span><i style={{ background: "#f3ece2" }} />≤1%</span>
            <span><i style={{ background: "#d9b892" }} />1–2%</span>
            <span><i style={{ background: "#ec9a74" }} />&gt;2%</span>
          </div>
        </Panel>
        <Panel className="s7" title="Headcount &amp; movement"
          sub="month-end headcount, with joiners and leavers">
          <HeadcountChart data={hcData} leftYear={leftYear}
            rightYear={rightYear} h={300} />
        </Panel>
    </>
  );
}
